import Vue from 'vue'
import Vuex from 'vuex'
// import custom pathify config (this is optional!)
import pathify from './pathify'
// import helper function
import { make } from 'vuex-pathify'
import VuexORM from '@vuex-orm/core'
import PatientData from '@/models/patientEMRs/PatientData'
import PatientDatas from '@/store/modules/patientEMRs/PatientDatas'
import PatientImage from '@/models/patientEMRs/PatientImage'
import PatientImages from '@/store/modules/patientEMRs/PatientImages'
import PatientVisit from '@/models/patientEMRs/PatientVisit'
import PatientVisits from '@/store/modules/patientEMRs/PatientVisits'
import PatientLabHead from '@/models/patientEMRs/PatientLabHead'
import PatientXrayHead from '@/models/patientEMRs/PatientXrayHead'
import PatientLabHeads from '@/store/modules/patientEMRs/PatientLabHeads'
import PatientXrayHeads from '@/store/modules/patientEMRs/PatientXrayHeads'
import PatientLabReport from '@/models/patientEMRs/PatientLabReport'
import PatientLabReports from '@/store/modules/patientEMRs/PatientLabReports'
import PatientXrayReport from '@/models/patientEMRs/PatientXrayReport'
import PatientXrayReports from '@/store/modules/patientEMRs/PatientXrayReports'
import PatientScreening from '@/models/patientEMRs/PatientScreening'
import PatientScreenings from '@/store/modules/patientEMRs/PatientScreenings'
import PatientDrugNoneDrug from '@/models/patientEMRs/PatientDrugNoneDrug'
import PatientDrugNoneDrugs from '@/store/modules/patientEMRs/PatientDrugNoneDrugs'
import PatientDiagOPD from '@/models/patientEMRs/PatientDiagOPD'
import PatientDiagOPDs from '@/store/modules/patientEMRs/PatientDiagOPDs'
import PatientDiagTextOPD from '@/models/patientEMRs/PatientDiagTextOPD'
import PatientDiagTextOPDs from '@/store/modules/patientEMRs/PatientDiagTextOPDs'
import PatientPhysicalImage from '@/models/patientEMRs/PatientPhysicalImage'
import PatientPhysicalImages from '@/store/modules/patientEMRs/PatientPhysicalImages'
import PatientOpdImage from '@/models/patientEMRs/PatientOpdImage'
import PatientOpdImages from '@/store/modules/patientEMRs/PatientOpdImages'
import PatientVisitDoctorTreatmentOPD from '@/models/patientEMRs/PatientVisitDoctorTreatmentOPD'
import PatientVisitDoctorTreatmentOPDs from '@/store/modules/patientEMRs/PatientVisitDoctorTreatmentOPDs'
import PatientDoctorNoteOPD from '@/models/patientEMRs/PatientDoctorNoteOPD'
import PatientDoctorNoteOPDs from '@/store/modules/patientEMRs/PatientDoctorNoteOPDs'
import PatientAppointmentData from '@/models/patientEMRs/PatientAppointmentData'
import PatientAppointmentDatas from '@/store/modules/patientEMRs/PatientAppointmentDatas'
import DocumentScan from '@/models/patientEMRs/DocumentScan'
import DocumentScans from '@/store/modules/patientEMRs/DocumentScans'

import DocumentScanIPD from '@/models/patientEMRs/DocumentScanIPD'
import DocumentScanIPDs from '@/store/modules/patientEMRs/DocumentScanIPDs'

import PatientOpdErProgressNote from '@/models/patientEMRs/PatientOpdErProgressNote'
import PatientOpdErProgressNotes from '@/store/modules/patientEMRs/PatientOpdErProgressNotes'
import PatientOpdFastTrackStemi from '@/models/patientEMRs/PatientOpdFastTrackStemi'
import PatientOpdFastTrackStemis from '@/store/modules/patientEMRs/PatientOpdFastTrackStemis'
import PatientEmrTemplate from '@/models/patientEMRs/PatientEmrTemplate'
import PatientEmrTemplates from '@/store/modules/patientEMRs/PatientEmrTemplates'
import PatientOpdAnestheticNote from '@/models/patientEMRs/PatientOpdAnestheticNote'
import PatientOpdAnestheticNotes from '@/store/modules/patientEMRs/PatientOpdAnestheticNotes'
import PatientEmrPtTemplate from '@/models/patientEMRs/PatientEmrPtTemplate'
import PatientEmrPtTemplates from '@/store/modules/patientEMRs/PatientEmrPtTemplates'
import PatientEmrPtIndicator from '@/models/patientEMRs/PatientEmrPtIndicator'
import PatientEmrPtIndicators from '@/store/modules/patientEMRs/PatientEmrPtIndicators'
import PatientEmrPtData from '@/models/patientEMRs/PatientEmrPtData'
import PatientEmrPtDatas from '@/store/modules/patientEMRs/PatientEmrPtDatas'
import PatientEmrPtDxData from '@/models/patientEMRs/PatientEmrPtDxData'
import PatientEmrPtDxDatas from '@/store/modules/patientEMRs/PatientEmrPtDxDatas'
import PatientEmrPtDxDataList from '@/models/patientEMRs/PatientEmrPtDxDataList'
import PatientEmrPtDxDataLists from '@/store/modules/patientEMRs/PatientEmrPtDxDataLists'
import PatientDentalData from '@/models/patientEMRs/PatientDentalData'
import PatientDentalDatas from '@/store/modules/patientEMRs/PatientDentalDatas'
import PatientDentalAreaData from '@/models/patientEMRs/PatientDentalAreaData'
import PatientDentalAreaDatas from '@/store/modules/patientEMRs/PatientDentalAreaDatas'
import PatientDentalVisitData from '@/models/patientEMRs/PatientDentalVisitData'
import PatientDentalVisitDatas from '@/store/modules/patientEMRs/PatientDentalVisitDatas'
import PatientPhamarcyADR from '@/models/patientEMRs/PatientPhamarcyADR'
import PatientPhamarcyADRs from '@/store/modules/patientEMRs/PatientPhamarcyADRs'
import PatientWebbaseUrl from '@/models/patientEMRs/PatientWebbaseUrl'
import PatientWebbaseUrls from '@/store/modules/patientEMRs/PatientWebbaseUrls'
import PatientPhamarcyCounseling from '@/models/patientEMRs/PatientPhamarcyCounseling'
import PatientPhamarcyCounselings from '@/store/modules/patientEMRs/PatientPhamarcyCounselings'
import PatientAdmitData from '@/models/patientEMRs/PatientAdmitData'
import PatientAdmitDatas from '@/store/modules/patientEMRs/PatientAdmitDatas'
import PatientAdmitDiagData from '@/models/patientEMRs/PatientAdmitDiagData'
import PatientAdmitDiagDatas from '@/store/modules/patientEMRs/PatientAdmitDiagDatas'
import PatientAdmitOperationData from '@/models/patientEMRs/PatientAdmitOperationData'
import PatientAdmitOperationDatas from '@/store/modules/patientEMRs/PatientAdmitOperationDatas'
import PatientAdmitRxOrderData from '@/models/patientEMRs/PatientAdmitRxOrderData'
import PatientAdmitRxOrderDatas from '@/store/modules/patientEMRs/PatientAdmitRxOrderDatas'
import PatientAdmitDischargeSummary from '@/models/patientEMRs/PatientAdmitDischargeSummary'
import PatientAdmitDischargeSummarys from '@/store/modules/patientEMRs/PatientAdmitDischargeSummarys'
import PatientAdmitDischargeType from '@/models/patientEMRs/PatientAdmitDischargeType'
import PatientAdmitDischargeTypes from '@/store/modules/patientEMRs/PatientAdmitDischargeTypes'
import PatientAdmitDischargeStatus from '@/models/patientEMRs/PatientAdmitDischargeStatus'
import PatientAdmitDischargeStatuss from '@/store/modules/patientEMRs/PatientAdmitDischargeStatuss'
import PatientAdmitRightsCenterChoice from '@/models/patientEMRs/PatientAdmitRightsCenterChoice'
import PatientAdmitRightsCenterChoices from '@/store/modules/patientEMRs/PatientAdmitRightsCenterChoices'
import PatientAdmitRightsCenterChoiceL1 from '@/models/patientEMRs/PatientAdmitRightsCenterChoiceL1'
import PatientAdmitRightsCenterChoiceL1s from '@/store/modules/patientEMRs/PatientAdmitRightsCenterChoiceL1s'
import PatientAdmitRightsCenterChoiceL2 from '@/models/patientEMRs/PatientAdmitRightsCenterChoiceL2'
import PatientAdmitRightsCenterChoiceL2s from '@/store/modules/patientEMRs/PatientAdmitRightsCenterChoiceL2s'
import PatientAdmitRightsCenterHead from '@/models/patientEMRs/PatientAdmitRightsCenterHead'
import PatientAdmitRightsCenterHeads from '@/store/modules/patientEMRs/PatientAdmitRightsCenterHeads'
import PatientAdmitRightsCenterList from '@/models/patientEMRs/PatientAdmitRightsCenterList'
import PatientAdmitRightsCenterLists from '@/store/modules/patientEMRs/PatientAdmitRightsCenterLists'
import PatientAdmitRightsCenterListL1 from '@/models/patientEMRs/PatientAdmitRightsCenterListL1'
import PatientAdmitRightsCenterListL1s from '@/store/modules/patientEMRs/PatientAdmitRightsCenterListL1s'
import PatientAdmitRightsCenterListL2 from '@/models/patientEMRs/PatientAdmitRightsCenterListL2'
import PatientAdmitRightsCenterListL2s from '@/store/modules/patientEMRs/PatientAdmitRightsCenterListL2s'
import PatientEmrIpfsImage from '@/models/patientEMRs/PatientEmrIpfsImage'
import PatientEmrIpfsImages from '@/store/modules/patientEMRs/PatientEmrIpfsImages'
import TmpAdmitRightsCenterListL1 from '@/models/patientEMRs/TmpAdmitRightsCenterListL1'
import TmpAdmitRightsCenterListL1s from '@/store/modules/patientEMRs/TmpAdmitRightsCenterListL1s'

import PatientEmrIpfsOperativeNoteImage from '@/models/patientEMRs/PatientEmrIpfsOperativeNoteImage'
import PatientEmrIpfsOperativeNoteImages from '@/store/modules/patientEMRs/PatientEmrIpfsOperativeNoteImages'
import PatientIpdImage from '@/models/patientEMRs/PatientIpdImage'
import PatientIpdImages from '@/store/modules/patientEMRs/PatientIpdImages'

import PatientEmrEarHearingDetail from '@/models/patientEMRs/PatientEmrEarHearingDetail'
import PatientEmrEarHearingDetails from '@/store/modules/patientEMRs/PatientEmrEarHearingDetails'
import PatientEmrDisabilityData from '@/models/patientEMRs/PatientEmrDisabilityData'
import PatientEmrDisabilityDatas from '@/store/modules/patientEMRs/PatientEmrDisabilityDatas'
import DrugNarcotic from '@/models/patientEMRs/DrugNarcotic'
import DrugNarcotics from '@/store/modules/patientEMRs/DrugNarcotics'

import PatientEmrConsultData from '@/models/patientEMRs/PatientEmrConsultData'
import PatientEmrConsultDatas from '@/store/modules/patientEMRs/PatientEmrConsultDatas'
import PatientMDRData from '@/models/patientEMRs/PatientMDRData'
import PatientMDRDatas from '@/store/modules/patientEMRs/PatientMDRDatas'
import PatientOpdHistoryPrintData from '@/models/patientEMRs/PatientOpdHistoryPrintData'
import PatientOpdHistoryPrintDatas from '@/store/modules/patientEMRs/PatientOpdHistoryPrintDatas'

import LabBtrChoice from '@/models/patientEMRs/LabBtrChoice'
import LabBtrChoices from '@/store/modules/patientEMRs/LabBtrChoices'
import LabBtrData from '@/models/patientEMRs/LabBtrData'
import LabBtrDatas from '@/store/modules/patientEMRs/LabBtrDatas'

import PatientAdmitDischargeSummaryCodingAudit from '@/models/patientEMRs/PatientAdmitDischargeSummaryCodingAudit'
import PatientAdmitDischargeSummaryCodingAudits from '@/store/modules/patientEMRs/PatientAdmitDischargeSummaryCodingAudits'

import PatientLabBloodGroup from '@/models/patientEMRs/PatientLabBloodGroup'
import PatientLabBloodGroups from '@/store/modules/patientEMRs/PatientLabBloodGroups'

import FilesScanType from '@/models/patientEMRs/FilesScanType'
import FilesScanTypes from '@/store/modules/patientEMRs/FilesScanTypes'
import ReferLookup from '@/models/patientEMRs/ReferLookup'
import ReferLookups from '@/store/modules/patientEMRs/ReferLookups'

Vue.use(Vuex)

// Create new instance of Database.
const database = new VuexORM.Database()

// Register Model and Module. The First argument is the Model, and
// second is the Module.
database.register(PatientData, PatientDatas)
database.register(PatientImage, PatientImages)
database.register(PatientVisit, PatientVisits)
database.register(PatientLabHead, PatientLabHeads)
database.register(PatientLabReport, PatientLabReports)
database.register(PatientXrayHead, PatientXrayHeads)
database.register(PatientXrayReport, PatientXrayReports)
database.register(PatientScreening, PatientScreenings)
database.register(PatientDrugNoneDrug, PatientDrugNoneDrugs)
database.register(PatientDiagOPD, PatientDiagOPDs)
database.register(PatientDiagTextOPD, PatientDiagTextOPDs)
database.register(PatientPhysicalImage, PatientPhysicalImages)
database.register(PatientOpdImage, PatientOpdImages)
database.register(PatientVisitDoctorTreatmentOPD, PatientVisitDoctorTreatmentOPDs)
database.register(PatientDoctorNoteOPD, PatientDoctorNoteOPDs)
database.register(PatientAppointmentData, PatientAppointmentDatas)
database.register(DocumentScan, DocumentScans)
database.register(PatientOpdErProgressNote, PatientOpdErProgressNotes)
database.register(PatientOpdFastTrackStemi, PatientOpdFastTrackStemis)
database.register(PatientEmrTemplate, PatientEmrTemplates)
database.register(PatientOpdAnestheticNote, PatientOpdAnestheticNotes)
database.register(PatientEmrPtTemplate, PatientEmrPtTemplates)
database.register(PatientEmrPtIndicator, PatientEmrPtIndicators)
database.register(PatientEmrPtData, PatientEmrPtDatas)
database.register(PatientEmrPtDxData, PatientEmrPtDxDatas)
database.register(PatientEmrPtDxDataList, PatientEmrPtDxDataLists)
database.register(PatientDentalData, PatientDentalDatas)
database.register(PatientDentalAreaData, PatientDentalAreaDatas)
database.register(PatientDentalVisitData, PatientDentalVisitDatas)
database.register(PatientPhamarcyADR, PatientPhamarcyADRs)
database.register(PatientWebbaseUrl, PatientWebbaseUrls)
database.register(PatientPhamarcyCounseling, PatientPhamarcyCounselings)
database.register(PatientAdmitData, PatientAdmitDatas)
database.register(PatientAdmitDiagData, PatientAdmitDiagDatas)
database.register(PatientAdmitOperationData, PatientAdmitOperationDatas)
database.register(PatientAdmitRxOrderData, PatientAdmitRxOrderDatas)
database.register(PatientAdmitDischargeSummary, PatientAdmitDischargeSummarys)
database.register(PatientAdmitDischargeType, PatientAdmitDischargeTypes)
database.register(PatientAdmitDischargeStatus, PatientAdmitDischargeStatuss)
database.register(PatientAdmitRightsCenterChoice, PatientAdmitRightsCenterChoices)
database.register(PatientAdmitRightsCenterChoiceL1, PatientAdmitRightsCenterChoiceL1s)
database.register(PatientAdmitRightsCenterChoiceL2, PatientAdmitRightsCenterChoiceL2s)
database.register(PatientAdmitRightsCenterHead, PatientAdmitRightsCenterHeads)
database.register(PatientAdmitRightsCenterList, PatientAdmitRightsCenterLists)
database.register(PatientAdmitRightsCenterListL1, PatientAdmitRightsCenterListL1s)
database.register(PatientAdmitRightsCenterListL2, PatientAdmitRightsCenterListL2s)
database.register(PatientEmrIpfsImage, PatientEmrIpfsImages)
database.register(TmpAdmitRightsCenterListL1, TmpAdmitRightsCenterListL1s)
database.register(PatientEmrIpfsOperativeNoteImage, PatientEmrIpfsOperativeNoteImages)
database.register(PatientIpdImage, PatientIpdImages)

database.register(PatientEmrEarHearingDetail, PatientEmrEarHearingDetails)
database.register(PatientEmrDisabilityData, PatientEmrDisabilityDatas)
database.register(DrugNarcotic, DrugNarcotics)
database.register(PatientEmrConsultData, PatientEmrConsultDatas)
database.register(PatientMDRData, PatientMDRDatas)
database.register(PatientOpdHistoryPrintData, PatientOpdHistoryPrintDatas)
database.register(LabBtrChoice, LabBtrChoices)
database.register(LabBtrData, LabBtrDatas)
database.register(PatientAdmitDischargeSummaryCodingAudit, PatientAdmitDischargeSummaryCodingAudits)

database.register(PatientLabBloodGroup, PatientLabBloodGroups)
database.register(FilesScanType, FilesScanTypes)
database.register(ReferLookup, ReferLookups)

database.register(DocumentScanIPD, DocumentScanIPDs)

// setup store
const state = {
	systems: {
		ErrorMessageApi: '',
		ErrorMessageApiStatus: false
	}
}

const mutations = make.mutations(state)

export default new Vuex.Store({
	// use the plugin
	plugins: [pathify.plugin, VuexORM.install(database)],
	// store properties
	state,
	mutations
})
